import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import OrderTracking from "@/pages/OrderTracking";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";

function App() {
  useEffect(() => {
    document.title = "Paulista's Lanches & Pizzas";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pedido/:id" element={<OrderTracking />} />
              <Route path="/gestao/login" element={<Login />} />
              <Route path="/gestao" element={<Dashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
